/* eslint-disable max-params, no-unused-expressions */
/**
 * @param {object} event
 * @param {number} yPosition
 * @param {string} behavior
 * @param {string} type
 * @param {Element} target
 */
function scrollTo(event = null, yPosition, behavior = 'smooth', type = 'vertical', target = null) {

    event && event.preventDefault();
    const container = target || window;

    if (type === 'vertical') {
        container.scroll({
            top: yPosition,
            behavior
        });
    } else {
        container.scroll({
            left: yPosition,
            behavior
        });
    }
}

export default scrollTo;
